import React from 'react';
import { Menu } from 'lucide-react';

const MobileHeader = ({ title, onMenuClick, customHeader }) => {
  if (customHeader) {
    return <div className="md:hidden">{customHeader}</div>;
  }

  return (
    <div className="md:hidden w-full bg-white border-b border-[#E4E7EC] py-2 px-3 flex items-center">
      <button
        onClick={onMenuClick}
        className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
      >
        <Menu size={20} color="#475367" />
      </button>
      <h1 className="flex-1 text-[17px] font-[600] text-[#1D2739] text-center pr-8">
        {title}
      </h1>
    </div>
  );
};

export default MobileHeader;
